/**
 * 角色选择
 * @author 3173
 * @date 2020-1-14
 */
import React from 'react';
import { connect } from 'dva';
import { framework_tool, component_tool, utils_tool  } from '@/tool';
import { modelUtils } from "../../../utils";
let { WizContainer } = framework_tool;
let { WizTag, WizTableTransfer, WizTooltip } = component_tool;
let { $$,checkStrLength } = utils_tool;
/**
 * 左边表格columns
 */
const leftTableColumns = [
  {
    dataIndex: 'title',
    title: '名称',
    width:100,
    ellipsis:true,
    render: (text) => <WizTooltip title={text} placement="topLeft" >{text}</WizTooltip>,
  },
  {
    dataIndex: 'code',
    title: '编码',
    width:100,
    ellipsis:true,
    render: (text) => <WizTooltip title={text} placement="topLeft" >{text}</WizTooltip>,
  },
  {
    dataIndex: 'remark',
    title: '备注',
    width:100,
    ellipsis:true,
    render: (text) => <WizTooltip title={text} placement="topLeft" >{text}</WizTooltip>,
  },
];

/**
 * 右边表格columns
 */
const rightTableColumns = [
  {
    dataIndex: 'title',
    title: '名称',
    width:100,
    ellipsis:true,
    render: (text) => <WizTooltip title={text} placement="topLeft" >{text}</WizTooltip>,
  },
  {
    dataIndex: 'code',
    title: '编码',
    width:100,
    ellipsis:true,
    render: (text) => <WizTooltip title={text} placement="topLeft" >{text}</WizTooltip>,
  }
];

class SetsRoleSelect extends WizContainer {

  componentName = 'SetsRoleSelect';

  constructor(props) {
    super(props);
    this.state = {
      targetKeys: [],
    }
    this.initTargetKeys = []
  }


  /**
   * 接口新增角色
   */
  _doRoleAdd = () => {
    if (this.props.record.id){
      let path = "";
      if(this.props.action&& this.props.action=='roleSetsRole'){
        path='roleSetsRole/addRoleSetsRole';
      }else if(this.props.action&& this.props.action=='roleManagement'){
        path = "roleManagement/batchSave";
      }

      this.doAction({
        path:path,
        payload: {
          key: "batchSave_"+this.props.action ,
          apiParams: {
            roleSetsId:this.props.record.id,
            roleIds:this.state.targetKeys

          }
        }
      });
    }else {
      wizNotice.warn("请先选择角色组");
    }
  };

  onChange = nextTargetKeys => {
    this.setState({ targetKeys: nextTargetKeys });
  };

  _componentDidMount = () => {
      this._getData();
      this._getApiRoleData();
  };

  propsAndStateOnChange = {
    roleSetsRoleList: this._setTargetKeys.bind(this),
    roleManagementRoleList:  this._setTargetKeysByManagement.bind(this),
    roleSetsResult:this._saveRolesOver.bind(this),
    roleManagementResult:this._saveRoleManagementOver.bind(this)
  }

  _setTargetKeys(nextProps, nextState) {
    let targetIds =[];
    nextProps.roleSetsRoleList.data.forEach(data =>{
      targetIds.push(data.roleId)
    });
    nextState.targetKeys = targetIds;
    this.initTargetKeys = targetIds
    return true;
  }

  _setTargetKeysByManagement(nextProps, nextState) {
    let targetIds =[];
    nextProps.roleManagementRoleList.data.forEach(data =>{
      targetIds.push(data.roleId)
    });
    nextState.targetKeys = targetIds;
    this.initTargetKeys = targetIds
    return true;
  }

  _saveRolesOver(nextProps, nextState){
    if(nextProps.roleSetsResult.code === 1){
      this.initTargetKeys = this.state['targetKeys'];
      wizNotice.success("操作成功");
      this.props.changeModal(false);
    }else{
      wizNotice.error(nextProps.roleSetsResult.msg);
    }
  }

  _saveRoleManagementOver(nextProps, nextState){
    if(nextProps.roleManagementResult.code === 1){
      wizNotice.success("操作成功");
      this.props.changeModal(false);
    }else{
      wizNotice.error(nextProps.roleSetsResult.msg);
    }
  }

  _getData() {
    this.doAction({
      path: "role/getListByCondition",
      payload: {
        key: "roleGetListByConditionKey",
        apiParams: {  }
      }
    });
  }

  /**
   * 根据接口id获取角色列表
   */
  _getApiRoleData() {
    let path = "roleManagement/list"
    if(this.props.action && this.props.action=='roleSetsRole'){
      path='roleSetsRole/list';
    }
    this.doAction({
      path: path,
      payload: {
        key: this.props.action + this.props.record.id,
        apiParams: {
          "roleSetsId":this.props.record.id,
        }
      }
    });
  }


  /**
   * 初始化已选角色
   */
  _doInitParams = () => {
    this.onChange(this.initTargetKeys)
  }


  _render() {
    const { targetKeys } = this.state;
    let listData = this.props.roleList.data?this.props.roleList.data:[];
    const mockData = [];
    let returnView = null;
    listData.forEach(roleData =>{
      mockData.push({
        key: roleData.id,
        title: roleData.name,
        code:roleData.code,
        remark:roleData.remark,
        disabled: false,
      })
    }
    );

      returnView  = <WizTableTransfer
      key={this.props.record.id}
      dataSource={mockData}
      targetKeys={targetKeys}
      onChange={this.onChange}
      filterOption={(inputValue, item) =>
        item.title.indexOf(inputValue) !== -1 || item.code.indexOf(inputValue) !== -1 || item.remark.indexOf(inputValue) !== -1
      }
      leftColumns={leftTableColumns}
      rightColumns={rightTableColumns}
    />

    return returnView;
  }
}

const mapStateToProps = (state, ownProps) => {
  const { role,roleSetsRole,roleManagement } = state;
  const roleList = modelUtils.getModelEntity(role, "roleGetListByConditionKey");
  const roleSetsRoleList = modelUtils.getModelEntity(roleSetsRole, ownProps.action + ownProps.record.id);
  const roleManagementRoleList = modelUtils.getModelEntity(roleManagement, ownProps.action + ownProps.record.id);
  const roleSetsResult = modelUtils.getModelEntity(roleSetsRole, 'batchSave_'+ownProps.action);
  const roleManagementResult = modelUtils.getModelEntity(roleManagement,'batchSave_'+ownProps.action);

  return {
    roleList: roleList,
    roleSetsRoleList:roleSetsRoleList,
    roleManagementRoleList:roleManagementRoleList,
    roleSetsResult: roleSetsResult,
    roleManagementResult: roleManagementResult
  }
};

const options = { withRef: true };

export default connect(mapStateToProps, null, null, options)(SetsRoleSelect);

